/* global FS, Viz, gRootURL */

import $ from "jquery";
import { runCallbacks } from "./td";

import { addCallback as addTableCallback, runCallbacks as runTableCallbacks, loadDashboard } from "./td-table.js";
import { initMarkupToolbars } from "./td-markup";
import "./td-kanban.js";
import { initMultiChoice } from "./td-multiselect";
import { printDocument, openDocument } from "./td-document";
import { initAiInstructions } from "./openAIGuide.js";
import { loadCodeMirror6 } from "./codemirror6-loader";

if($.cookie("td-dense") != null)
	document.documentElement.className += " dense";

var hasImgLoadingSupport = window.HTMLImageElement && window.HTMLImageElement.prototype && 'loading' in window.HTMLImageElement.prototype;
if(hasImgLoadingSupport) {
	window.addEventListener("beforeprint", function() {
		document.querySelectorAll("img[loading=lazy]").forEach(function(e) {
			e.loading = "eager";
		});
	});
}

(function() {
	var f = $.scrollIntoView;
	if(f) { // provide default options
		$.scrollIntoView = function(elt, options) {
			if(options === undefined)
				options = true;
			if(options === true || options === false)
				options = { block: options ? "start" : "end" };
			options = $.extend({}, { behavior: "auto", block: "start", select: "#td-toptab.ui-sticky,.fs-gridheader.ui-sticky" }, options);
			return f(elt, options);
		};
	}
})();

addTableCallback(function patchPrevNextUrls(ctx) {
	// return;

	var alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_";

	function encodeInt32(n) {
		var s = "";
		n = n >>> 0;
		var bits = 5;
		var msb = Math.pow(2, bits);
		var mask = msb - 1;
		do {
			var x = n & mask;
			n >>>= bits;
			if (n) x |= msb;
			s += alphabet[x];
		} while (n);
		return s;
	}

	function encodeIdArray(arr, id, maxLength, forwardOnly) {
		var pos = arr.indexOf(id << 1);
		if (pos < 0)
			pos = arr.indexOf((id << 1) | 1);
		var s;
		var seqPrev = [];
		var seqNext = [];
		var maxD = arr.length - pos;
		if (!forwardOnly && pos > maxD)
			maxD = pos;
		for (var i = 0; i < maxD; i++) {
			var pn = pos + i;
			var pp = pos - 1 - i;
			if (pn < arr.length) {
				s = encodeInt32(arr[pn]);
				if (s.length < maxLength) {
					seqNext.push(s);
					maxLength -= s.length;
				} else {
					break;
				}
			}
			if (!forwardOnly && pp >= 0) {
				s = encodeInt32(arr[pp]);
				if (s.length < maxLength) {
					seqPrev.unshift(s);
					maxLength -= s.length;
				} else {
					break;
				}
			}
		}
		return seqPrev.concat(seqNext).join("");
	}

	function buildSeq(view, selector) {
		var seq = [];
		var aset = $(selector, view);
		aset.each(function () {
			var href = $(this).attr("href");
			var n = href.indexOf("?");
			if (n >= 0) {
				var qs = $.qstring(href.substring(n));
				var id = qs.get("id") >>> 0;
				if (!id) return;
				seq.push(id);
			}
		});
		return seq;
	}

	function buildViewEditSeq(view, viewSelector, editSelector) {
		function clear0(v) { return v << 1; }
		function set0(v) { return (v << 1) | 1; }
		function check0(v) { return (v << 1) | (editSeq.indexOf(v) >= 0 ? 1 : 0); }

		var viewSeq = buildSeq(view, viewSelector);
		var editSeq = [];
		var editable;
		if (viewSelector === editSelector) {
			editSeq = viewSeq;
			editable = true;
		} else if (!editSelector) {
			editSeq = null;
		} else {
			editSeq = buildSeq(view, editSelector);
			if (!viewSeq.length) {
				viewSeq = editSeq;
				editable = true;
			} else if (!editSeq.length) {
				editable = false;
			}
		}

		return $.map(viewSeq, editable === true ? set0 : editable === false ? clear0 : check0, editSeq);
	}

	function handleClick(view, element, viewSelector, editSelector) {

		var fromEdit = editSelector === viewSelector;
		var href = element.attr("href");
		var maxLength = 16128 - 4 - 10 - href.length; // max length - max id length - "seq=";
		var n = href.indexOf("?");
		if (n >= 0) {
			var qs = $.qstring(href.substring(n));
			var seqArr = buildViewEditSeq(view, viewSelector, editSelector, fromEdit);
			var id = +qs.get("id");
			var seq = encodeIdArray(seqArr, id, maxLength);
			qs.set("seq", seq);
			element.attr("href", href.substring(0, n + 1) + qs.toString());
		}
	}

	$(".td-prevnext", ctx).on("click", "a.ui-action-view", function (event) {
		handleClick($(event.delegateTarget), $(this), "a.ui-action-view", "a.ui-action-edit");
	});
	$(".td-savenext", ctx).on("click", "a.ui-action-edit", function (event) {
		handleClick($(event.delegateTarget), $(this), "a.ui-action-edit", "a.ui-action-edit");
	});
});

// add here a snippets of code to execute when page is ready
// leave larger code in separate files

$(document).on("click", "a[data-popup]", function() {
	window.open(this.href, this.target, this.getAttribute("data-popup"), true);
	return false;
});

// onDOMReady
$(function () {
	runCallbacks();
	initMarkupToolbars();
	runTableCallbacks();

	(function (selectdc) {
		if (selectdc.length) {
			try {
				var tz = new Intl.DateTimeFormat().resolvedOptions().timeZone;
				if (/Europe\//.test(tz)) {
					selectdc.filter("[value=eu]").prop("checked", true);
				}
			} catch (e) {
			}
		}
	})($("#frm_select_datacenter input[name=dc]"));

	// init second factor
	(function initSecondFactor(form) {
		if (form.length) {
			FS.addScript(gRootURL + "/js/jquery-signalR-2.4.3.min.js", function () {
				var loginId = $.qstring().get("loginId");
				var hubConnectionOptions = { logging: false, qs: { "loginId": loginId } };
				var connection = $.hubConnection(gRootURL, hubConnectionOptions);
				connection.createHubProxy("login2FAHub")
					.on("processSignedToken", function (instance, token, signature) {
						if (loginId === instance) {
							form.attr("novalidate", "");
							$("input[name=\"postbackaction\"]", form).val("verifytoken");
							$("input[name=\"token\"]", form).val(token);
							$("input[name=\"signature\"]", form).val(signature);
							$("input[name=\"code\"],.ui-action-verify,.ui-action-send", form).prop("disabled", true);
							form[0].submit();
						}
					});
				connection.start().fail(function (e) {
					console.error("SignalR init failed", e);
				});
			});
			setTimeout(() => history.back(), 3 * 60 * 1000);
		}
	})($("#frm_login2fa"));

	// help box toggle
	$("#td-helpbox>header").on("click", function () {
		$(this).toggleClass("ui-icon-sortdesc ui-icon-sortasc").next().slideToggle(100);
	});

	// add focus hightlight for grid-layouts
	(function initLayoutHighlight() {
		$("body.td-signed div.ui-gridlayout.fs-edit").on("focusin focusout", "dl", function (e) {
			var t = $(this);
			if (e.type == "focusin") {
				t.data("backgroundColorSave", t.css("backgroundColor"));
				t.css("backgroundColor", t.find(">dd").css("backgroundColor"));
			} else {
				t.css("backgroundColor", t.data("backgroundColorSave"));
			}
		});
	})();
	// init workspace selector
	(function initWorkspaceSelector() {
		$("#td-usermenu+.ui-menu")
			.popup("#td-usermenu").menu().on("click", "a", function () {
				if ($(this).next(".ui-menu").length)
					return false;
			});

		$("#td-wks>.ui-menu").popup("parent").menu().on("click", function (e) {
			e = $(e.target);
			var h = e.attr("href");
			if (h && h.charAt(0) === "#")
				h = h.substring(1);
			if (h && !isNaN(1 * h)) {
				var n, l = location, p = l.pathname, ap = p.replace(/^(.*\/db\/[-\d]+)\/.*/i, "$1");
				$.cookie("td-wks", h || null, 3E8, ap);
				if ((n = p.lastIndexOf("/")) >= 0)
					l.href = p.substring(0, n) + "/default.aspx";
				else
					l.reload(true);
			}
		});
	})();
	(function initSearchBox() {
		var box = $("#td-mysearchbox", "#td-menubtm");
		if (box.length) {
			var selector = "table.fs-grid, #td-applibrary>section";
			if ($(selector).length) {
				$("#td-mysearchbox", "#td-menubtm").quicksearch({ selector: selector, children: "article" });
			} else {
				$("input,button", "#frm_search").prop("disabled", true);
			}
		}
		$("#frm_search", "#td-menubtm").on("focusin focusout", function (e) {
			$(this).toggleClass("ui-focus", e.type === "focusin");
		}).on("submit", function (e) {
			var qs = $.qstring().get("keywords");
			var s = this.keywords;
			if (qs === s.value || !/\S/.test(s.value)) {
				s.focus();
				e.preventDefault();
				e.stopPropagation();
				return false;
			}
		});
	})();
	// init create new button
	(function initCreateNewButton() {
		$("#td-createnew>a.ui-button").toolaction({ from: $("#td-createnew>ul.ui-menu").menu() });
	})();
	// init applib accordions
	(function initAccordionMenus() {
		var currentCategory = "#frm_appnew";
		$("#td-appcategories").on("click", "a[href^=\"#\"]", function (e) {
			$("a[href^=\"#\"].ui-selected", "#td-appcategories").removeClass("ui-selected");
			var h = $(e.target).addClass("ui-selected").attr("href");
			if (h !== currentCategory) {
				$(currentCategory).hide();
				$(currentCategory = h).show();
			}
			e.preventDefault();
		});
	})();
	// init header/footer scroll
	(function initScrolls() {
		$("#td-header,#td-footer").sticky({ left: 0, anchor: "window", placeholder: "fixHeight" });
		var top = 0;
		var tab = $("#td-toptab");
		if (tab.length && !window.matchMedia("screen and (max-height: 640px)").matches) {
			tab.sticky({ left: 0, top: 0, anchor: "window", placeholder: "fixHeight" });
			top += tab.outerHeight();
		}
		$("#td-sidebar").sticky({ top: top, bottom: 0, placeholder: "fixSize" });
		FS.initGrids(null, null, { top: top });
	})();
	// init multichoice selectors
	initMultiChoice();

	// init daterange pickers
	(function initDateRangePickers() {
		$("div.td-daterange").each(function () {
			var d = $(this);
			var b = d.find(">button");
			var id = d.data("id");
			// init menu
			var popup = d.find(">div.ui-popup");
			popup.on("click", "a", function (e) { e.preventDefault(); })
				.find(">div>ul").menu({
					select: function (event, ui) {
						var text = ui.item.find("a").text();
						var from = ui.item.data("from");
						d.find("input.date[name=\"" + id + "_from\"]").val(from);
						var to = ui.item.data("to");
						d.find("input.date[name=\"" + id + "_to\"]").val(to);
						d.children("span.td-daterange-pickers").toggle(!!ui.item.data("custom"));
						d.find(">button>span").text(text);
						return false;
					}
				});
			popup.popup(b);
		});
	})();
	// customize tooltips
	(function initCustomTips() {
		$("div.ui-gridlayout dl.ui-col > dt > abbr[title], table.fs-layout td.fs-help").tooltip({
			content: function () {
				return $("<a>").text($(this).attr("title") || "").html().replace(/\r\n/g, "<br/>");
			}
		}).on("click", function () {
			$(this).tooltip("open");
		});
	})();
	// set up font resizer
	(function initFontResizer() {
		$("#td-fontresizer").on("click", "a[href^=\"#\"]", function () {
			var dense = $(this).attr("href") === "#dense";
			$.cookie("td-dense", dense ? "1" : null, 3E8, location.pathname.replace(/^(.*\/db\/[-\d]+)\/.*/i, "$1"));
			location.reload();
			return false;
		});
	})();
	(function initV3Switch() {
		$("a.v3-switch-v2").on("click", function (e) {
			$.cookie("v3", "1", 3E8, location.pathname.replace(/^(.*\/db\/[-\d]+)\/.*/i, "$1"), null, location.protocol == "https:");
			location.reload(true);
			e.preventDefault();
		});
	})();
	(function initCopyHref() {
		var tt;
		$("a.td-copyhref").on("click", function (e) {
			if (e.button === 0 && !e.altKey && !e.ctrlKey && !e.metaKey && !e.shiftKey) {
				e.preventDefault();
				var el = $(this);
				var textToCopy = el.prop("href");
				navigator.clipboard.writeText(textToCopy).then(function () {
					if (!tt) {
						tt = $("<div>", { "class": "ui-tooltip" }).text("Link is copied to clipboard").appendTo(document.body);
					}
					tt.position({ my: "center top", at: "center bottom", of: el });
					setTimeout(function () { tt.remove(); tt = null; }, 1000);
				}, function (err) {
					alert(err);
				});
			}
		});
	})();
	(function initProfiler() {
		var tt;
		$(".td-copystring").on("click", function () {
			var el = $(this);
			var textToCopy = el.find(">input").val();
			navigator.clipboard.writeText(textToCopy).then(function () {
				if (!tt) {
					tt = $("<div>", { "class": "ui-tooltip" }).text("Copied to clipboard").appendTo(document.body);
				}
				tt.position({ my: "center top", at: "center bottom", of: el });
				setTimeout(function () { tt.remove(); tt = null; }, 1000);
			}, function (err) {
				alert(err);
			});
		});
		$("li.td-profiler-item > div.ui-icon-expanded,li.td-profiler-item > div.ui-icon-collapsed").on("click", function () {
			$(this).toggleClass("ui-icon-expanded ui-icon-collapsed");
		});
	})();
	(function initDocPrint() {
		$(document).on("click", "a.td-docprint", function (e) {
			var url = $(e.currentTarget).attr("href");
			e.preventDefault();
			printDocument(url);
		});
	})();
	openDocument(window.gApiConfig && window.gApiConfig.opendoc);
	// end
	(function initTypeInSelect() {
		$("input[data-options]").each(function () {
			var e = $(this);
			e.attr("autocomplete", e.attr("name") + "_" + new Date().valueOf());
			var options = JSON.parse(e.attr("data-options"));
			e.autocomplete({ minLength: 0, source: function (_request, response) { response(options); } });
		}).on("focus", function () { $(this).autocomplete("search", ""); });
	})();

	(function initCodeMirrors() {
		if (document.querySelector(".js-codemirror")) {
			loadCodeMirror6(function (CodeMirror) {
				document.querySelectorAll(".js-codemirror[data-cm-mode]").forEach(elt => {
					CodeMirror.initTextFileEditor(elt, { submitToSave: true });
				});
			});
		}
	})();
	(function initGraphVis() {
		var graphviz = document.getElementById("graphviz");
		if (graphviz) {
			FS.addScript(gRootURL + '/js/viz-3.12.0.min.js', function () {
				$("#td-main").removeClass("td-twocols");
				$("#td-sidebar-right").remove();
				Viz.instance().then(function (viz) {
					var text = graphviz.getAttribute("data-graph");
					var element = viz.renderSVGElement(text);
					element.querySelectorAll("title").forEach(title => title.remove());
					graphviz.replaceChildren(element);
				}, function (error) {
					graphviz.replaceChildren(error.toString());
				});
			});
		}
	})();
	(function initShowTarget() {
		$(document).on("click", "a.js-show-target", function (e) { e.preventDefault();  $($(this).attr("href")).show(); });
	})();


	loadDashboard();
});
// onLoad
$(window).on("load", function() {
	// scroll hash into view
	(function scrollHashIntoView() {
		var h = location.hash;
		if(/^#anchor_/.test(h)) {
			$.scrollIntoView(h);
		}
	})();
	// send resize event to window to notify everyone about current layout
	$(window).trigger("resize");

	// TODO: uncomment to test
	initAiInstructions();
});
